import { jsxs, jsx } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import "react";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import { styled } from "@mui/material";
import { ShieldCheckSolid as e } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/shield-check-solid.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Direction } from "../../../foundations/direction.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
import Grid from "../../../../node_modules/@mui/material/Grid/Grid.es.js";
import Box from "../../../../node_modules/@mui/material/Box/Box.es.js";
import { Typography } from "../../typography/typography.es.js";
const wrapperStyle = {
  display: Displaying.flex,
  flexDirection: Direction.row,
  gap: Spacing["250"],
  alignItems: Alignment.center,
  lineHeight: "166%"
};
const GridIconWrapper = styled(Grid)({
  height: Spacing["1250"]
});
const BoxWrapper = styled(Box)({
  wrapperStyle
});
function InnerLabel({
  label,
  icon,
  className
}) {
  return /* @__PURE__ */ jsxs(Box, { className, style: {
    display: Displaying.flex,
    flexDirection: Direction.row,
    gap: Spacing["250"],
    whiteSpace: "nowrap"
  }, children: [
    /* @__PURE__ */ jsx(Typography, { color: "primary", variant: "caption", children: label }),
    icon && /* @__PURE__ */ jsx(GridIconWrapper, { item: true, children: /* @__PURE__ */ jsx(BoxWrapper, { children: /* @__PURE__ */ jsx(e, { color: "secondary", fontSize: "small" }) }) })
  ] });
}
export {
  InnerLabel
};
//# sourceMappingURL=inner-label.es.js.map
